import { authorizedAxios } from './axiosInstances';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api`;
const main = 'NWAPP';
const sub = 'LockDesk';

class LockDeskService {
  getLockDeskVM(id) {
    return authorizedAxios.get(`${API_URL}/${main}/${sub}/LockVM?id=${id}`).then((response) => {
      return response.data;
    });
  }

  getLockPipeline() {
    return authorizedAxios.get(`${API_URL}/${main}/${sub}/LockPipeline`).then((response) => {
      return response.data;
    });
  }

  getLockInAgreement(confirmLock) {
    return authorizedAxios
      .patch(`${API_URL}/${main}/${sub}/LockInAgreement`, confirmLock)
      .then((response) => {
        return response;
      });
  }

  acceptLock(confirmLock) {
    return authorizedAxios
      .put(`${API_URL}/${main}/${sub}/AcceptLock`, confirmLock, {})
      .then((response) => {
        return response;
      });
  }

  repricingLockAndSave(confirmLock) {
    return authorizedAxios
      .put(`${API_URL}/${main}/${sub}/RepricingLockAndSave`, confirmLock)
      .then((response) => {
        return response;
      });
  }

  getFileScenario(loanNumber, selectedCompPlanID) {
    return authorizedAxios
      .get(
        `${API_URL}/${main}/${sub}/FileScenario?loanNumber=${loanNumber}&selectedCompPlanID=${selectedCompPlanID}`
      )
      .then((response) => {
        return response.data;
      });
  }

  updateStatusLockedFile(loanNumber, status, lockDeskId) {
    return authorizedAxios
      .put(
        `${API_URL}/${main}/${sub}/SetStatusLockedFile?loanNumber=${loanNumber}&status=${status}&lockDeskId=${lockDeskId}`,
        null
      )
      .then((response) => {
        return response;
      });
  }

  compareLockInformation(loanNumber) {
    return authorizedAxios
      .get(`${API_URL}/${main}/${sub}/CompareLockInformation?loanNumber=${loanNumber}`)
      .then((response) => {
        return response.data;
      });
  }
}

export default new LockDeskService();
